export default {
    // Home page
    home: {
        title: 'Timer.today • Best Online Timer, Stopwatch & World Clock Tools',
        description: '⏰Free online timing tools including countdown timer, precision stopwatch and world clock. Perfect for productivity, cooking, studying, sports training and time zone management. No ads.',
        keywords: ['online timer', 'countdown timer', 'stopwatch online', 'world clock', 'productivity timer', 'pomodoro timer', 'cooking timer', 'free timer tool', 'browser timer', 'time management'],
        ogTitle: 'Professional Online Timer Tools - timer.today',
        ogDescription: 'Professional online timing tool platform providing countdown timer, stopwatch and world clock features',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Timer.Today",
            "description": "Free online timing tools including countdown timer, precision stopwatch and world clock. Perfect for productivity, cooking, studying, sports training and time zone management. No ads.",
            "url": "https://timer.today",
            "applicationCategory": "Productivity",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "Online timer",
                "Sound alerts",
                "Multiple timer presets",
                "Stopwatch",
                "World clock"
            ],
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "reviewCount": "503"
            }
        }
    },

    // Timer page
    timer: {
        // 主要SEO标签优化
        title: 'Online Timer • Free Countdown Tool with Sound Alerts',
        description: '⏰Online countdown timer with custom settings. Quick 10min/15min start for Pomodoro, study, work breaks. Free + sound alerts 🔔!',

        // 关键词优化
        keywords: [
            '10 minute timer', '15 minute timer', '30 minute timer',
            'pomodoro timer', 'study timer', 'work break timer',
            'timer with sound alerts', 'online countdown tool',
            'productivity timer', 'time management tool'
        ],

        // 社交媒体SEO优化
        ogTitle: 'Free Online Timer - Perfect for Study & Work Breaks',
        ogDescription: '⏰ Set custom countdown timers with sound alerts. Perfect for Pomodoro technique, study sessions, and productivity. No signup required!',
        // ogImage: 'https://timer.today/images/timer-social-preview.jpg', // 建议添加
        ogUrl: 'https://timer.today/timer', // 建议添加

        // Twitter优化（建议添加）
        twitterTitle: 'Free Online Timer - Boost Your Productivity',
        twitterDescription: '⏰ Custom countdown timer with sound alerts. Perfect for Pomodoro, study breaks, and time management. Start now!',
        twitterCard: 'summary_large_image',

        // 结构化数据优化
        jsonLd:
            {
                "@context": "https://schema.org",
                "@type": "WebApplication",
                "name": "Online Timer - Free Countdown Tool",
                "description": "Free online countdown timer with custom time settings, sound alerts, and preset options. Perfect for productivity and time management.",
                "url": "https://timer.today/timer",
                "applicationCategory": "Productivity",
                "operatingSystem": "Any",
                "browserRequirements": "Requires JavaScript",
                "offers": {
                    "@type": "Offer",
                    "price": "0",
                    "priceCurrency": "USD",
                    "availability": "https://schema.org/InStock"
                },
                "features": [
                    {
                        "@type": "WebPage",
                        "name": "1 minute timer",
                        "url": "https://timer.today/timer/1-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "3 minute timer",
                        "url": "https://timer.today/timer/3-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "5 minute timer",
                        "url": "https://timer.today/timer/5-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "10 minute timer",
                        "url": "https://timer.today/timer/10-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "15 minute timer",
                        "url": "https://timer.today/timer/15-minute-timer"
                    },
                    {
                        "@type": "WebPage",
                        "name": "30 minute timer",
                        "url": "https://timer.today/timer/30-minute-timer"
                    }
                ],
                "isAccessibleForFree": true,
                "publisher": {
                    "@type": "Organization",
                    "name": "Timer.Today",
                    "url": "https://timer.today"
                },
                "potentialAction": {
                    "@type": "UseAction",
                    "target": "https://timer.today/timer",
                    "name": "Start Timer"
                },
                "aggregateRating": {
                    "@type": "AggregateRating",
                    "ratingValue": "4.8",
                    "ratingCount": "70",
                    "bestRating": "5"
                }
            }
    },

    // Stopwatch page
    stopwatch: {
        // Title优化：从79字符缩减到55字符，关键词前置
        title: 'Online Stopwatch • High-Precision Timer with Milliseconds',

        // Description优化：添加emoji，强调免费和精准度
        description: '⏱️ Professional online stopwatch with millisecond precision. Perfect for sports training, fitness workouts, cooking & study timing. Free + accurate! 🎯',

        // 关键词扩展：增加长尾关键词和使用场景
        keywords: [
            // 核心关键词
            'online stopwatch', 'precision stopwatch', 'millisecond timer',
            'digital stopwatch', 'free stopwatch', 'accurate stopwatch',

            // 功能关键词
            'stopwatch with milliseconds', 'high precision timer',
            'professional stopwatch', 'lap timer', 'split timer',

            // 使用场景关键词
            'sports timer', 'training stopwatch', 'fitness timer',
            'cooking stopwatch', 'workout timer', 'running stopwatch',
            'study timer', 'interval timer', 'racing stopwatch',

            // 长尾关键词
            'online stopwatch tool', 'stopwatch for training',
            'precise timing tool', 'millisecond precision timer',
            'sports training stopwatch', 'fitness workout timer'
        ],

        // 社交媒体优化
        ogTitle: 'Free Online Stopwatch - Millisecond Precision Timer',
        ogDescription: '⏱️ Professional stopwatch with precise timing for sports, fitness, cooking & training. Millisecond accuracy, lap times, and split timing. Start now!',
        ogUrl: 'https://timer.today/stopwatch',

        // Twitter优化
        twitterTitle: 'Precision Online Stopwatch - Perfect for Sports & Training',
        twitterDescription: '⏱️High-precision stopwatch with millisecond accuracy. Perfect for athletes, coaches, and anyone needing precise timing.',
        twitterCard: 'summary_large_image',

        // 结构化数据全面优化
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Online Stopwatch - High-Precision Timer",
            "description": "Professional online stopwatch with millisecond precision. Perfect for sports training, fitness workouts, cooking timing, and precise time measurement.",
            "url": "https://timer.today/stopwatch",
            "applicationCategory": "Productivity", // 更广泛的分类
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",

            // 价格信息（提升搜索展示）
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock"
            },

            // 详细功能列表（增强搜索相关性）
            "featureList": [
                "Millisecond precision timing",
                "Start, stop, reset controls",
                "Full screen",
                "Sound notifications",
                "No ads"
            ],

            // 免费声明
            "isAccessibleForFree": true,

            // 发布者信息
            "publisher": {
                "@type": "Organization",
                "name": "Timer.Today",
                "url": "https://timer.today"
            },
            // 相关工具（内链SEO）
            "relatedLink": [
                "https://timer.today/timer",
                "https://timer.today/worldclock"
            ],
            "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.7",
                "ratingCount": "89",
                "bestRating": "5"
            }
        }
    },

    // World Clock page
    worldclock: {
        // Title优化：突出"live"实时性，添加视觉符号
        title: 'World Clock • Live Global Time Zones & Current Time',

        // Description优化：强调免费、实时、多城市
        description: '🌍 Live world clock showing current time in 200+ cities worldwide. Real-time time zones, meeting planner & timezone converter. Free & accurate! ⏰',

        // 关键词大幅扩展：城市+功能+使用场景
        keywords: [
            // 核心功能词（最重要）
            'world clock', 'global time zones', 'time now', 'timezone converter',

            // 主要使用场景
            'time in india', 'new york time', 'global conference time',

            // 技术特点
            'live world clock', 'real time world clock', 'current world time',

            // 主要地区（只选最重要的）
            'usa time zones', 'europe time zones', 'asia time zones',

            // 核心城市（只选搜索量最高的）
            'new york time', 'london time', 'tokyo time', 'sydney time',

            // 长尾词（高转化）
            'what time is it worldwide', 'international time comparison'
        ],

        // 社交媒体优化
        ogTitle: 'Live World Clock - Current Time in 200+ Global Cities',
        ogDescription: '🌍 Check current time worldwide instantly! Perfect for international business meetings, travel planning, and staying connected globally. Free live updates!',
        ogImage: 'https://timer.today/images/worldclock-social-preview.jpg',
        ogUrl: 'https://timer.today/worldclock',

        // Twitter优化
        twitterTitle: 'World Clock - Never Miss Global Meeting Times Again',
        twitterDescription: '🌍 Live world clock with 200+ cities. Perfect for international business, travel, and global coordination. Real-time updates!',
        twitterCard: 'summary_large_image',

        // 结构化数据全面优化
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "World Clock - Live Global Time Zones",
            "description": "Real-time world clock displaying current time in over 200 major cities worldwide. Perfect for international business, travel planning, and global coordination.",
            "url": "https://timer.today/worldclock",
            "applicationCategory": "Productivity", // 更广泛的分类
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",

            // 价格信息
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD",
                "availability": "https://schema.org/InStock"
            },

            // 详细功能列表
            "featureList": [
                "Live time display for 200+ cities",
                "Real-time timezone updates",
                "Multiple timezone comparison",
                "Bookmark favorite cities",
                "Full screen"
            ],

            // 覆盖地区（扩大搜索覆盖）
            "serviceArea": [
                {"@type": "Place", "name": "North America"},
                {"@type": "Place", "name": "Europe"},
                {"@type": "Place", "name": "Asia Pacific"},
                {"@type": "Place", "name": "Middle East"},
                {"@type": "Place", "name": "Africa"},
                {"@type": "Place", "name": "Oceania"},
                {"@type": "Place", "name": "Worldwide"}
            ],

            // 免费声明
            "isAccessibleForFree": true,

            // 发布者信息
            "publisher": {
                "@type": "Organization",
                "name": "Timer.Today",
                "url": "https://timer.today"
            },
        }
    },

    // Not Found page
    notfound: {
        title: 'Page Not Found - timer.today',
        description: 'Sorry, the page you are looking for does not exist. Please return to our homepage to use our online timer, stopwatch and world clock tools.',
        keywords: ['404', 'not found', 'timer tools'],
        ogTitle: 'Page Not Found - timer.today',
        ogDescription: 'The page you are looking for does not exist'
    },

    // Terms page
    terms: {
        title: 'Terms of Service - timer.today',
        description: 'Terms of Service and usage agreement for timer.today online timing tools platform. Learn about our service rules, user rights and responsibilities.',
        keywords: ['terms of service', 'user agreement', 'timer tools terms'],
        ogTitle: 'Terms of Service - timer.today',
        ogDescription: 'Terms of Service and usage agreement for timer.today online timing tools platform',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Terms of Service",
            "description": "Terms of Service and usage agreement for timer.today online timing tools platform"
        }
    },

    // Dynamic timer pages (1min, 3min, etc.)
    timerMinutes: (minutesNum: number) => {
        const useCases = {
            1: 'eye rest breaks, quick meditation, tea brewing',
            3: 'egg boiling, coffee brewing, short breaks',
            5: 'meditation practice, soft-boiled eggs, quick workouts',
            10: 'study breaks, phone calls, reading sessions',
            15: 'Pomodoro work sessions, medium workouts, deep learning',
            20: 'focused work periods, fitness exercises, skill training',
            25: 'standard Pomodoro technique, deep work, professional study',
            30: 'long focus sessions, workout routines, deep learning',
            45: 'deep work periods, speech practice, professional training',
            60: 'work time blocks, course learning, extended workouts'
        }[minutesNum] || 'productivity and time management';

        return {
            title: `${minutesNum} Minute Timer - Online Countdown Timer for Productivity`,
            description: `Free ${minutesNum}-minute countdown timer perfect for ${useCases}. Features sound alerts, fullscreen mode and custom settings. Start your ${minutesNum}-minute timer now!`,
            keywords: [`${minutesNum} minute timer`, `${minutesNum}min timer`, 'countdown timer', 'productivity timer', useCases.split(', ')[0], useCases.split(', ')[1]],
            ogTitle: `${minutesNum} Minute Timer - timer.today`,
            ogDescription: `${minutesNum}-minute countdown timer with sound alerts and desktop notifications, perfect for ${useCases}`,
            jsonLd: {
                "@context": "https://schema.org",
                "@type": "WebApplication",
                "name": `${minutesNum} Minute Timer`,
                "description": `${minutesNum}-minute countdown timer with sound alerts and desktop notifications, perfect for ${useCases}`,
                "applicationCategory": "Productivity"
            }
        };
    },

    // Dynamic city pages
    city: ({ cityName, countryName, timezone }: { cityName: string, countryName: string, timezone: string }) => ({
        title: `Current Time in ${cityName} - Live ${cityName} Time & Time Zone`,
        description: `🌍 What time is it in ${cityName}, ${countryName}? Check current local time, timezone (${timezone}), UTC offset, and date. Perfect for scheduling meetings and international calls. Free live updates!`,
        keywords: [
            `time in ${cityName}`,
            `${cityName} time`,
            `current time ${cityName}`,
            `${cityName} timezone`,
            `${cityName} clock`,
            `what time is it in ${cityName}`,
            `${cityName} local time`,
            `time zone ${cityName}`,
            `${cityName} ${countryName} time`,
            'world clock',
            'international time'
        ],
        ogTitle: `Current Time in ${cityName}, ${countryName} - Live Clock`,
        ogDescription: `Check current time in ${cityName} (${timezone}). Real-time updates with timezone information and date. Perfect for international scheduling.`,
        ogUrl: `https://timer.today/worldclock/time-in/${cityName.toLowerCase().replace(/\s+/g, '-')}`,
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": `Current Time in ${cityName}`,
            "description": `Current local time in ${cityName}, ${countryName} with timezone ${timezone}`,
            "url": `https://timer.today/worldclock/time-in/${cityName.toLowerCase().replace(/\s+/g, '-')}`,
            "isPartOf": {
                "@type": "WebSite",
                "name": "Timer.Today",
                "url": "https://timer.today"
            },
            "about": {
                "@type": "Place",
                "name": cityName,
                "address": {
                    "@type": "PostalAddress",
                    "addressCountry": countryName
                }
            },
            "mainEntity": {
                "@type": "ClockInfo",
                "name": `${cityName} Time`,
                "timezone": timezone
            }
        }
    }),

    // Timestamp converter page
    timestamp: {
        title: 'Unix Timestamp Converter - Epoch Time to Date & Code Snippets | timer.today',
        description: 'Free online Unix timestamp converter. Convert epoch time to date and vice versa. Includes timestamp cheat sheets for Python, Java, MySQL, JavaScript, and PHP.',
        keywords: [
            'timestamp converter',
            'unix timestamp',
            'epoch time converter',
            'timestamp to date',
            'date to timestamp',
            'unix time converter',
            'python timestamp',
            'java timestamp',
            'mysql timestamp',
            'javascript timestamp',
            'php timestamp',
            'iso 8601',
            'current epoch time',
            'timestamp cheat sheet'
        ],
        ogTitle: 'Unix Timestamp Converter & Epoch Time Tool',
        ogDescription: 'Convert epoch time to date with code examples for Python, Java, MySQL, JavaScript, and PHP. Free online timestamp converter.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Unix Timestamp Converter",
            "description": "Free online Unix timestamp converter with code snippets for Python, Java, MySQL, JavaScript, and PHP",
            "url": "https://timer.today/timestamp",
            "applicationCategory": "DeveloperApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "Unix timestamp to date conversion",
                "Date to timestamp conversion",
                "Current epoch time display",
                "Code examples for Python, Java, MySQL, JavaScript, PHP",
                "Seconds and milliseconds format support",
                "ISO 8601 format output"
            ]
        }
    },

    // YouTube Timestamp Link Generator
    youtubeLink: {
        title: 'YouTube Timestamp Link Generator - Create Shareable Video Links | timer.today',
        description: '📺 Generate YouTube links that start at specific times. Perfect for sharing video moments on social media, email, and forums. Works with all YouTube videos!',
        keywords: [
            'youtube timestamp link',
            'youtube timestamp',
            'youtube link with timestamp',
            'youtube link at specific time',
            'youtube share timestamp',
            'youtube timestamp url',
            'youtube start time link',
            'youtube video timestamp',
            'youtube timestamp generator',
            'youtube link generator',
            'youtube embed timestamp'
        ],
        ogTitle: 'YouTube Timestamp Link Generator - Share Videos at Exact Moments',
        ogDescription: 'Create YouTube links that start at any time. Generate shareable URLs for social media, email, and embed codes with timestamps.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "YouTube Timestamp Link Generator",
            "description": "Generate YouTube links with timestamps for sharing specific video moments",
            "url": "https://timer.today/youtube-timestamp-link",
            "applicationCategory": "UtilitiesApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "Generate short and full YouTube links",
                "Create embed codes with timestamps",
                "Live video preview",
                "Multiple URL format support",
                "One-click copy"
            ]
        }
    },

    // YouTube Timestamp Generator (for chapters/comments)
    youtubeGenerator: {
        title: 'YouTube Timestamp Generator - Create Video Chapters & Comments | timer.today',
        description: '🎬 Generate YouTube timestamps for video descriptions and comments. Create chapters, convert seconds to timestamps, and improve video SEO. Free tool!',
        keywords: [
            'youtube timestamp generator',
            'youtube timestamp',
            'youtube chapters',
            'youtube video chapters',
            'youtube timestamp comment',
            'youtube timestamp format',
            'youtube chapter generator',
            'youtube timestamp converter',
            'youtube description timestamps',
            'youtube video timestamps',
            'how to add youtube chapters'
        ],
        ogTitle: 'YouTube Timestamp Generator - Create Chapters & Comments',
        ogDescription: 'Generate formatted timestamps for YouTube video descriptions and comments. Create chapters to improve viewer experience and SEO.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "YouTube Timestamp Generator",
            "description": "Generate YouTube timestamps for video chapters, descriptions, and comments",
            "url": "https://timer.today/youtube-timestamp-generator",
            "applicationCategory": "UtilitiesApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "Video chapter generator",
                "Seconds to timestamp converter",
                "Comment timestamp templates",
                "Batch conversion",
                "Format validation"
            ]
        }
    },

    // MySQL Timestamp Page
    mysqlTimestamp: {
        title: 'MySQL Timestamp Tutorial - UNIX_TIMESTAMP & FROM_UNIXTIME Guide | timer.today',
        description: '📘 Complete MySQL timestamp guide. Learn UNIX_TIMESTAMP(), FROM_UNIXTIME(), TIMESTAMP vs DATETIME, timezone handling, and performance optimization with practical SQL examples.',
        keywords: [
            'mysql timestamp',
            'mysql unix_timestamp',
            'mysql from_unixtime',
            'mysql timestamp to date',
            'mysql date to timestamp',
            'mysql timestamp format',
            'mysql timestamp vs datetime',
            'mysql timestamp timezone',
            'mysql current timestamp',
            'mysql timestamp functions',
            'mysql epoch time'
        ],
        ogTitle: 'MySQL Timestamp Tutorial - Complete Guide with SQL Examples',
        ogDescription: 'Master MySQL timestamp functions: UNIX_TIMESTAMP(), FROM_UNIXTIME(), timezone handling, and performance tips. Includes practical SQL examples.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "name": "MySQL Timestamp Complete Guide",
            "description": "Comprehensive tutorial on MySQL timestamp functions and best practices",
            "url": "https://timer.today/mysql-timestamp",
            "author": {
                "@type": "Organization",
                "name": "Timer.Today"
            },
            "datePublished": "2024-01-04",
            "educationalLevel": "Intermediate",
            "proficiencyLevel": "Intermediate"
        }
    },

    // SQL Timestamp Page (Universal)
    sqlTimestamp: {
        title: 'SQL Timestamp Tutorial - MySQL, PostgreSQL, Oracle, SQL Server | timer.today',
        description: '📘 Complete SQL timestamp guide for all major databases. Master MySQL UNIX_TIMESTAMP, PostgreSQL EXTRACT(EPOCH), Oracle date arithmetic, and SQL Server DATEDIFF_BIG with practical examples.',
        keywords: [
            'sql timestamp',
            'mysql timestamp',
            'postgresql timestamp',
            'oracle timestamp',
            'sql server timestamp',
            'sql unix timestamp',
            'sql timestamp to date',
            'sql date to timestamp',
            'sql current timestamp',
            'sql timestamp functions',
            'timestamp sql',
            'sql timestamp format',
            'sql timestamp comparison',
            'sql epoch time',
            'database timestamp'
        ],
        ogTitle: 'SQL Timestamp Tutorial - Complete Guide for All Major Databases',
        ogDescription: 'Master timestamp handling in MySQL, PostgreSQL, Oracle, and SQL Server. Comprehensive guide with syntax comparison and practical SQL examples.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "name": "SQL Timestamp Complete Guide for All Databases",
            "description": "Comprehensive tutorial on timestamp functions across MySQL, PostgreSQL, Oracle, and SQL Server",
            "url": "https://timer.today/sql-timestamp",
            "author": {
                "@type": "Organization",
                "name": "Timer.Today"
            },
            "datePublished": "2025-01-05",
            "dateModified": "2025-01-05",
            "educationalLevel": "Intermediate",
            "proficiencyLevel": "Intermediate",
            "keywords": "SQL, MySQL, PostgreSQL, Oracle, SQL Server, timestamp, database"
        }
    },

    // Python Timestamp Page
    pythonTimestamp: {
        title: 'Python Timestamp Tutorial - datetime, time, calendar Module Guide | timer.today',
        description: '🐍 Complete Python timestamp guide. Master datetime, time, and calendar modules. Learn timezone handling, timestamp conversion, and practical code examples.',
        keywords: [
            'python timestamp',
            'python get timestamp',
            'python datetime timestamp',
            'python timestamp to datetime',
            'python datetime to timestamp',
            'python time timestamp',
            'python timestamp to date',
            'python unix timestamp',
            'python timestamp timezone',
            'python timestamp milliseconds'
        ],
        ogTitle: 'Python Timestamp Tutorial - datetime & time Module Guide',
        ogDescription: 'Master Python timestamp handling with datetime, time, and calendar modules. Includes timezone handling and practical examples.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "name": "Python Timestamp Complete Guide",
            "description": "Comprehensive tutorial on Python timestamp handling with datetime and time modules",
            "url": "https://timer.today/python-timestamp",
            "programmingLanguage": "Python"
        }
    },

    // JavaScript Timestamp Page
    javascriptTimestamp: {
        title: 'JavaScript Timestamp Tutorial - Date Object & Methods Guide | timer.today',
        description: '⚡ Complete JavaScript timestamp guide. Master Date object, Date.now(), getTime(), timestamp conversion, and popular libraries like Day.js.',
        keywords: [
            'javascript timestamp',
            'js timestamp',
            'javascript get timestamp',
            'javascript date timestamp',
            'date.now javascript',
            'javascript timestamp to date',
            'javascript date to timestamp',
            'javascript unix timestamp',
            'javascript timestamp milliseconds',
            'javascript date gettime'
        ],
        ogTitle: 'JavaScript Timestamp Tutorial - Date Object Guide',
        ogDescription: 'Master JavaScript Date object and timestamp methods. Includes modern libraries and practical examples.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "TechArticle",
            "name": "JavaScript Timestamp Complete Guide",
            "description": "Comprehensive tutorial on JavaScript Date object and timestamp handling",
            "url": "https://timer.today/javascript-timestamp",
            "programmingLanguage": "JavaScript"
        }
    },

    // Discord Timestamp Generator
    discordTimestamp: {
        title: 'Discord Timestamp Generator - Create <t:format> Codes | timer.today',
        description: '🎮 Generate Discord timestamps with automatic timezone conversion. Create <t:timestamp:format> codes for events, countdowns, and announcements. Works in all Discord channels!',
        keywords: [
            'discord timestamp',
            'discord timestamp generator',
            'discord time format',
            'discord timestamp code',
            'discord <t> format',
            'discord timestamp converter',
            'discord dynamic timestamp',
            'discord time converter',
            'discord event timestamp',
            'discord countdown',
            'discord timezone converter'
        ],
        ogTitle: 'Discord Timestamp Generator - Auto Timezone Conversion',
        ogDescription: 'Generate Discord timestamp codes that automatically adjust to every user\'s local timezone. Perfect for events, raids, and community scheduling.',
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebApplication",
            "name": "Discord Timestamp Generator",
            "description": "Generate Discord timestamp codes with automatic timezone conversion for events and announcements",
            "url": "https://timer.today/discord-timestamp-generator",
            "applicationCategory": "UtilitiesApplication",
            "operatingSystem": "Any",
            "browserRequirements": "Requires JavaScript",
            "offers": {
                "@type": "Offer",
                "price": "0",
                "priceCurrency": "USD"
            },
            "featureList": [
                "7 Discord timestamp formats",
                "Automatic timezone conversion",
                "Live preview",
                "One-click copy",
                "Format reference table",
                "Common use cases guide"
            ]
        }
    },

    // Dynamic country pages
    country: ({ countryName, citiesCount }: { countryName: string, citiesCount: number }) => ({
        title: `Time in ${countryName} - Current Local Time & Time Zones`,
        description: `🌍 Check current time in ${countryName} across ${citiesCount}+ cities. Real-time timezone updates, UTC offsets, and local times. Perfect for business meetings and international coordination.`,
        keywords: [
            `time in ${countryName}`,
            `${countryName} time`,
            `${countryName} timezone`,
            `current time ${countryName}`,
            `${countryName} clock`,
            `what time is it in ${countryName}`,
            `${countryName} local time`,
            `${countryName} cities time`,
            'world clock',
            'international time'
        ],
        ogTitle: `Current Time in ${countryName} - ${citiesCount}+ Cities`,
        ogDescription: `View current time in ${countryName} across all major cities. Real-time timezone information with live updates.`,
        ogUrl: `https://timer.today/worldclock/country/${countryName.toLowerCase().replace(/\s+/g, '-')}`,
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": `Time in ${countryName}`,
            "description": `Current local time in ${countryName} covering ${citiesCount}+ cities`,
            "url": `https://timer.today/worldclock/country/${countryName.toLowerCase().replace(/\s+/g, '-')}`,
            "isPartOf": {
                "@type": "WebSite",
                "name": "Timer.Today",
                "url": "https://timer.today"
            },
            "about": {
                "@type": "Place",
                "name": countryName,
                "geo": {
                    "@type": "Country",
                    "name": countryName
                }
            }
        }
    })
};